import { useEffect } from 'react';
import NProgress from 'nprogress';
import { Spinner } from 'react-bootstrap';

function SuspenseLoader() {
  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
      }}
    >
      {/* <Spinner animation="border" role="status" style={{ width: '4rem', height: '4rem' }}>
        <span className="visually-hidden">Loading...</span>
      </Spinner> */}
    </div>
  );
}

export default SuspenseLoader;
